import type { SelectOptionType } from './SelectSearchControl'

export function toSelectOptionType(option: string): SelectOptionType {
  return {
    value: option,
    name: option,
  }
}
